/* Gioco «Giro di pista» nella finestra della linguetta −10% (snippets/mq-giro.liquid). All'apertura della finestra, a chi
   non è iscritto e non l'ha già finito in questa visita, mostra il gioco al posto dell'invito; al traguardo torna l'invito,
   con il modulo di sempre. Il veicolo va solo avanti e segue il dito solo se resta entro 40 px dalla pista. */
(function () {
  var g = document.querySelector('[data-mq-giro]');
  var dlg = document.getElementById('mq-gift-dialog');
  if (!g || !dlg) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var invite = dlg.querySelector('[data-mq-signup-invite]');
  var play = g.querySelector('[data-mq-giro-play]'), done = g.querySelector('[data-mq-giro-done]');
  var svg = g.querySelector('svg'), car = g.querySelector('[data-mq-giro-car]'), body = g.querySelector('[data-mq-giro-body]');
  var wait = g.querySelector('[data-mq-giro-wait]'), path = g.querySelector('[data-mq-giro-path]');
  var pts = [], idx = 0, drag = false, run = false, arrived = false;
  var seen = function () { try { return sessionStorage.getItem('mq_giro') === '1'; } catch (x) { return false; } };

  function sample() {
    var L = path.getTotalLength();
    pts = [];
    for (var s = 0; s <= L; s += 2) { var p = path.getPointAtLength(s); pts.push({ x: p.x, y: p.y }); }
    var e = path.getPointAtLength(L); pts.push({ x: e.x, y: e.y });
  }
  function place() {
    var c = pts[idx], n = pts[Math.min(pts.length - 1, idx + 3)], b = pts[Math.max(0, idx - 3)];
    car.setAttribute('transform', 'translate(' + c.x.toFixed(1) + ' ' + c.y.toFixed(1) + ')');
    body.setAttribute('transform', 'rotate(' + (Math.atan2(n.y - b.y, n.x - b.x) * 180 / Math.PI).toFixed(1) + ')');
    var pc = Math.round(100 * idx / (pts.length - 1));
    car.setAttribute('aria-valuenow', pc);
    car.setAttribute('aria-valuetext', pc >= 100 ? g.dataset.finish : pc ? g.dataset.lap.replace('{n}', pc) : g.dataset.start);
  }
  function check() {
    if (arrived || idx < pts.length - 1) return;
    arrived = true; drag = false;
    try { sessionStorage.setItem('mq_giro', '1'); } catch (x) {}
    setTimeout(finish, reduce.matches ? 0 : 350);
  }
  function finish() {
    play.hidden = true; done.hidden = false; invite.hidden = false;
    done.querySelector('[data-mq-giro-done-title]').focus();
  }
  function toEnd() {
    if (run) return;
    if (reduce.matches) { idx = pts.length - 1; place(); check(); return; }
    var from = idx, to = pts.length - 1, t0 = null, dur = 1400 * (to - from) / to + 200;
    run = true;
    requestAnimationFrame(function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      k = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      idx = Math.round(from + (to - from) * k); place();
      if (k < 1) requestAnimationFrame(step); else { run = false; check(); }
    });
  }
  function follow(e) {
    var m = svg.getScreenCTM(); if (!m) return;
    var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY; pt = pt.matrixTransform(m.inverse());
    // ponytail: cerca solo 90 campioni avanti (circa 180 unità), così all'incrocio della M non salta sull'altro ramo
    var best = idx, dmin = Infinity;
    for (var j = idx; j < Math.min(pts.length, idx + 90); j++) {
      var d = Math.hypot(pts[j].x - pt.x, pts[j].y - pt.y);
      if (d < dmin) { dmin = d; best = j; }
    }
    if (dmin * (m.a || 1) > 40) { wait.textContent = g.dataset.wait; return; }
    wait.textContent = '';
    if (best > idx) { idx = best; place(); check(); }
  }

  car.addEventListener('pointerdown', function (e) { if (run) return; drag = true; car.setPointerCapture(e.pointerId); e.preventDefault(); });
  car.addEventListener('pointermove', function (e) { if (drag) follow(e); });
  car.addEventListener('pointerup', function () { drag = false; });
  car.addEventListener('pointercancel', function () { drag = false; });
  car.addEventListener('keydown', function (e) {
    if (run) return;
    if (/^Arrow/.test(e.key)) { e.preventDefault(); idx = Math.min(pts.length - 1, idx + Math.round(pts.length * .03)); place(); check(); }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toEnd(); }
  });
  g.querySelector('[data-mq-giro-go]').addEventListener('click', toEnd);

  // All'apertura: il gioco solo se l'invito è in vista (chi è già iscritto vede il suo codice) e non è già finito.
  new MutationObserver(function () {
    if (!dlg.open || invite.hidden || seen()) return;
    if (!pts.length) sample();
    idx = 0; arrived = false; place();
    g.hidden = false; play.hidden = false; done.hidden = true; invite.hidden = true;
    g.querySelector('[data-mq-giro-title]').focus();
  }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
})();
